module.exports = __webpack_public_path__ + "static/media/cuboid1.8685d5a1.jpg";